// /home/szymon/kreator2/frontend/src/components/ProjectsPanel.js
// v1.1.1 – Drobna korekta logów, reszta identyczna.

import React, { useState, useEffect } from "react";

export default function ProjectsPanel({ backendUrl }) {
  const [projects, setProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");

  console.log("[ProjectsPanel] => RENDER => projects.length=", projects.length);

  const fetchProjects = async () => {
    try {
      setError("");
      let url = `${backendUrl}/admin/projects`;
      if (searchTerm) {
        url += `?search=${encodeURIComponent(searchTerm)}`;
      }
      console.log("[ProjectsPanel] => fetchProjects =>", url);

      const res = await fetch(url, { credentials: "include" });
      console.log("[ProjectsPanel] => fetch /admin/projects => res.status=", res.status);
      if (!res.ok) {
        throw new Error("Błąd pobierania listy projektów.");
      }
      const data = await res.json();
      console.log("[ProjectsPanel] => pobrano data=", data, "length=", data.length);
      setProjects(data);
    } catch (err) {
      console.error("[ProjectsPanel] fetchProjects =>", err);
      setError("Nie udało się pobrać listy projektów.");
    }
  };

  useEffect(() => {
    console.log("[ProjectsPanel] => useEffect => start fetchProjects()");
    fetchProjects();
    // eslint-disable-next-line
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("[ProjectsPanel] => handleSearch => re-fetch with searchTerm=", searchTerm);
    fetchProjects();
  };

  return (
    <div className="orders-container" style={{ marginTop: 20 }}>
      <h3>Lista Publicznych Projektów</h3>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={handleSearch} className="orders-search">
        <label>Wyszukaj (publicKey/email):</label>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="orders-input"
          style={{ marginLeft: 8, marginRight: 8 }}
        />
        <button type="submit" className="orders-button">
          Szukaj
        </button>
      </form>

      <table className="orders-table" style={{ marginTop: 15 }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>PublicKey</th>
            <th>Email</th>
            <th>TemplateID</th>
            <th>Link do projektu</th>
          </tr>
        </thead>
        <tbody>
          {projects.length === 0 ? (
            <tr>
              <td colSpan={5} style={{ textAlign: "center" }}>
                Brak projektów.
              </td>
            </tr>
          ) : (
            projects.map((proj) => {
              const link = `/public/project-${proj.publicKey}-${proj.accessKey}`;
              return (
                <tr key={proj.id}>
                  <td>{proj.id}</td>
                  <td>{proj.publicKey}</td>
                  <td>{proj.email || "-"}</td>
                  <td>{proj.templateId || "-"}</td>
                  <td>
                    <a
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#00f", textDecoration: "none" }}
                    >
                      Otwórz
                    </a>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
